import { Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';

import { ReactComponent as MoreIcon } from '@assets/icons/more_icon.svg';

import CustomDropdown from '@components/CustomDropdown';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import WastageTab from '@features/materials/components/WastageTab';
import { PURCHASE_PRICE_TYPES } from '@features/materials/MaterialConstants';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { updateSearchResultForFabric } from '@store/supplier/action';

import { restrictMaterialBooking } from '@services/materialService';

import ApiClient from '@lib/apiClient';

import {
	fetchNitexUsers,
	fetchRACLocation,
	getTransactionType,
	inventoryEditPermission,
	isFabric,
	isNumeric,
	STATUS,
	TRANSACTION_TYPE,
	userNameSet
} from '@utils/MaterialsUtil';
import {
	changeDateFormat,
	getCountryList,
	getUserInfo,
	printApiError,
	validateFloatNumber
} from '@utils/Util';

import { BASE_FRONT_END_URL } from '@/constants/constant';

import AdditionalFabricModal from '@/features/materials/components/AdditionalFabricModal';

import RestrictedInfo from './RestrictedInfo';

const MaterialInventory = ({
	materialData,
	onclose,
	viewType,
	consumptionUnit = '',
	isIssueTab,
	setIsIssueTab,
	isReceiveTabSelected = false,
	requisitionId = null,
	callBack
}) => {
	const [show, setShow] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [transactionType, setTransactionType] = useState(
		isReceiveTabSelected
			? TRANSACTION_TYPE.RECEIVE
			: isIssueTab
				? TRANSACTION_TYPE.ISSUE
				: getTransactionType(materialData)
	);
	const [selectedSupplier, setSelectedSupplier] = useState(null);
	const [userList, setUserList] = useState([]);
	const [fixedUserList, setFixedUserList] = useState([]);
	const [selectedUser, setSelectedUser] = useState(null);
	const [selectedRequestedUser, setSelectedRequestedUser] = useState(null);
	const [, setRACLocationList] = useState([]);
	const [fixedRACLocationList, setFixedRACLocationList] = useState([]);
	const [selectedRACLocation, setSelectedRACLocation] = useState(null);

	const [issueByUser, setIssueByUser] = useState(null);
	const [issueQuantity, setIssueQuantity] = useState(null);
	const [itemRemarks, setItemRemarks] = useState(null);
	const [itemChallan, setItemChallan] = useState(null);
	const [itemInvoice, setItemInvoice] = useState(null);
	const [item, setItem] = useState(null);

	const [inventoryResponse, setInventoryResponse] = useState(null);
	const [receiveInventoryResponseList, setReceiveInventoryResponseList] = useState([]);
	const [wastageInventoryResponseList, setWastageInventoryResponseList] = useState([]);
	const [issueInventoryResponseList, setIssueInventoryResponseList] = useState([]);
	const [unitPriceCurrencyType, setUnitPriceCurrencyType] = useState(null);
	const [updateDetails, setUpdateDetails] = useState({});
	const [selectedCountry, setSelectedCountry] = useState({});

	const [totalQuantity, setTotalQuantity] = useState(0);
	const [totalFixedQuantity, setTotalFixedQuantity] = useState(0);

	const [totalUnitPrice, setTotalUnitPrice] = useState(0);
	const [totalFixedUnitPrice, setTotalFixedUnitPrice] = useState(0);
	const [errorObj, setErrorObj] = useState({});
	const [receiveInventoryErrorObj, setReceiveInventoryErrorObj] = useState({});
	const dispatch = useDispatch();
	const userInfo = getUserInfo();
	const [selectedAdditionalFabric, setSelectedAdditionalFabric] = useState(null);

	const handleClose = (value) => {
		setItem(null);
		setShow(false);
		onclose(value);
		setIsIssueTab && setIsIssueTab(false);
		dispatch(updateSearchResultForFabric(null, false));
	};

	const dataClear = () => {
		setErrorObj({});
		setItem(null);
		setSelectedSupplier(null);
		setSelectedUser(null);
		setSelectedRequestedUser(null);
		setSelectedRACLocation(null);
		setItemRemarks(null);
		setItemChallan(null);
		setItemInvoice(null);
		setReceiveInventoryErrorObj({});
	};

	const calculationQtyAndPriceForReceivedOrIssue = () => {
		let totalQuantity = 0;
		let totalPrice = 0;

		if (transactionType.value === TRANSACTION_TYPE.ISSUE.value) {
			issueInventoryResponseList.map((item) => {
				if (item?.status !== STATUS.RETURNED && isNumeric(item?.quantity))
					totalQuantity += parseFloat(item?.quantity);
			});
			if (item !== undefined && isNumeric(item?.issueQuantity)) {
				totalQuantity += parseFloat(item?.issueQuantity);
			}
		} else if (transactionType.value === TRANSACTION_TYPE.RECEIVE.value) {
			receiveInventoryResponseList.map((item) => {
				if (item?.status !== STATUS.DISABLED && !isNaN(item?.quantity)) {
					let unitPrice = item?.unitPrice ? parseFloat(item?.unitPrice) : 0;
					let quantity = parseFloat(item?.quantity);
					totalQuantity += quantity;
					totalPrice += unitPrice * quantity;
				}
			});
			setTotalUnitPrice(totalPrice);
			setTotalFixedUnitPrice(totalPrice);
		}
		setTotalQuantity(totalQuantity);
		setTotalFixedQuantity(totalQuantity);
	};

	useEffect(() => {
		getAllIssueAndReceivedInventory().then();
	}, []);

	useEffect(() => {
		if (transactionType.value === TRANSACTION_TYPE.RECEIVE.value) {
			receiveInventoryResponseList.map((obj) => {
				if (obj.id === itemRemarks?.id) obj.remarks = itemRemarks?.remarks;
			});
		} else if (transactionType.value === TRANSACTION_TYPE.ISSUE.value) {
			issueInventoryResponseList.map((obj) => {
				if (obj.id === itemRemarks?.id) obj.remarks = itemRemarks?.remarks;
			});
		}
	}, [itemRemarks]);

	useEffect(() => {
		if (transactionType.value === TRANSACTION_TYPE.RECEIVE.value) {
			receiveInventoryResponseList.map((obj) => {
				if (obj.id === itemChallan?.id) obj.chalanNo = itemChallan?.chalanNo;
			});
		}
	}, [itemChallan]);

	useEffect(() => {
		if (transactionType.value === TRANSACTION_TYPE.RECEIVE.value) {
			receiveInventoryResponseList.map((obj) => {
				if (obj.id === itemInvoice?.id) obj.invoiceNo = itemInvoice?.invoiceNo;
			});
		}
	}, [itemInvoice]);

	useEffect(() => {
		if (transactionType.value === TRANSACTION_TYPE.ISSUE.value) {
			issueInventoryResponseList.map((obj) => {
				if (obj.id === issueByUser?.itemId) {
					obj.user = { id: issueByUser?.id, name: issueByUser?.value };
				}
			});

			setIssueInventoryResponseList([...issueInventoryResponseList]);
		}
	}, [issueByUser]);

	useEffect(() => {
		if (transactionType.value === TRANSACTION_TYPE.ISSUE.value) {
			issueInventoryResponseList.map((obj) => {
				if (obj.id === issueQuantity?.id) {
					if (isNumeric(issueQuantity?.quantity))
						obj.quantity = parseFloat(issueQuantity?.quantity);
					else obj.quantity = undefined;
				}
			});

			setIssueInventoryResponseList([...issueInventoryResponseList]);
		}
	}, [issueQuantity]);

	useEffect(() => {
		calculationQtyAndPriceForReceivedOrIssue();
	}, [issueInventoryResponseList, receiveInventoryResponseList]);

	useEffect(() => {
		dataClear();
		calculationQtyAndPriceForReceivedOrIssue();
	}, [transactionType]);

	useEffect(() => {
		if (fixedUserList.length === 0)
			fetchNitexUsers(undefined, setUserList, setIsLoading, true, setFixedUserList);
		if (transactionType.value === TRANSACTION_TYPE.RECEIVE.value && fixedRACLocationList.length === 0)
			fetchRACLocation(undefined, setRACLocationList, setIsLoading, true, setFixedRACLocationList);
	}, [transactionType]);

	const totalQtySet = (quantityValue, key) => {
		let value = quantityValue;

		if (value !== undefined && value.length > 0) {
			setItem({
				...item,
				[key]: quantityValue
			});
			let quantity = parseFloat(quantityValue);
			setTotalQuantity(totalFixedQuantity + quantity);
			if (item?.unitPrice) {
				setTotalUnitPrice(quantity * item?.unitPrice + totalFixedUnitPrice);
			} else setTotalUnitPrice(totalFixedUnitPrice);
		} else {
			setItem({
				...item,
				[key]: undefined
			});
			setTotalQuantity(totalFixedQuantity);
			setTotalUnitPrice(totalFixedUnitPrice);
		}
	};

	const totalPriceSet = (e) => {
		e.preventDefault();
		let value = e.target.value;
		if (value !== undefined && value.length > 0) {
			setItem({
				...item,
				unitPrice: e.target.value
			});
			let unitPrice = parseFloat(e.target.value);
			if (item?.receiveQuantity) {
				setTotalUnitPrice(item?.receiveQuantity * unitPrice + totalFixedUnitPrice);
			} else setTotalUnitPrice(totalFixedUnitPrice);
		} else {
			setItem({
				...item,
				unitPrice: undefined
			});
			setTotalUnitPrice(totalFixedUnitPrice);
		}
	};

	const onItemClick = (item) => {
		if (item?.title === 'Supplier') {
			setSelectedSupplier(item);
		} else if (item?.title === 'User') {
			setSelectedUser(item);
		} else if (item?.title === 'Location') {
			setSelectedRACLocation(item);
		} else if (item?.title === 'Requested by') {
			setSelectedRequestedUser(item);
		}
	};

	const errorClassSet = () => {
		setIsLoading(true);
		let error = {};
		if (transactionType.value === TRANSACTION_TYPE.ISSUE.value) {
			issueInventoryResponseList.map((issue, index) => {
				if (
					issue.status === STATUS.BOOKED &&
					issue.quantity !== undefined &&
					issue.user === undefined
				) {
					error = { ...error, ['user' + index]: 'common-border-error' };
				} else error = { ...error, ['user' + index]: '' };
			});
			if (selectedUser === null && item?.issueQuantity !== undefined) {
				error = { ...error, user: 'common-border-error' };
			} else {
				error = { ...error, user: '' };
			}
		}
		setErrorObj(error);
		setIsLoading(false);
	};
	const isValidField = () => {
		if (transactionType.value === TRANSACTION_TYPE.ISSUE.value) {
			let errorCheck = false;
			issueInventoryResponseList.map((issue) => {
				if (
					issue.status === STATUS.BOOKED &&
					issue.quantity !== undefined &&
					issue.user === undefined
				)
					errorCheck = true;
			});
			if (!item?.issueQuantity && !errorCheck) {
				return null;
			} else if (!selectedUser && !errorCheck) {
				return true;
			}
			return errorCheck;
		}
	};

	const onSubmit = async () => {
		if (!materialData) return;
		let isValitation = isValidField();
		errorClassSet();
		if (
			(transactionType.value === TRANSACTION_TYPE.RECEIVE.value &&
				isInvalidReceivedTableValidation()) ||
			isValitation
		) {
			return;
		}
		if (
			transactionType.value === TRANSACTION_TYPE.ISSUE.value &&
			item?.issueQuantity > inventoryResponse?.stockQuantity
		) {
			toastError('Stock not available', true);
			return;
		}

		let list = [];
		let obj = {};
		if (transactionType.value === TRANSACTION_TYPE.RECEIVE.value) {
			list = receiveInventoryResponseList.map((obj) => {
				return {
					id: obj?.id,
					materialId: obj?.materialId,
					// supplierId: obj?.supplier?.id,
					materialType: obj?.materialType,
					userId: obj?.user?.id,
					requestedUserId: obj?.requestedUser?.id,
					locationId: obj?.location?.id,
					date: obj?.date,
					quantity: obj?.quantity,
					unitPrice: obj?.unitPrice,
					remarks: obj?.remarks,
					status: obj?.status,
					chalanNo: obj?.chalanNo,
					invoiceNo: obj?.invoiceNo
				};
			});
			obj = {
				materialId: materialData?.id,
				// supplierId: selectedSupplier?.id,
				materialType: selectedSupplier?.materialType,
				userId: selectedUser?.id,
				requestedUserId: selectedRequestedUser?.id,
				locationId: selectedRACLocation?.id,
				date: new Date().toISOString().slice(0, 10),
				quantity: item?.receiveQuantity,
				unitPrice: item?.unitPrice,
				currency: unitPriceCurrencyType?.value,
				remarks: item?.receiveRemarks,
				chalanNo: item?.chalanNo,
				invoiceNo: item?.invoiceNo
			};
			if (requisitionId) {
				obj.materialRequisitionId = requisitionId;
			}
		} else if (transactionType.value === TRANSACTION_TYPE.ISSUE.value) {
			list = issueInventoryResponseList.map((obj) => {
				return {
					id: obj?.id,
					materialId: obj?.materialId,
					userId:
						obj?.status === STATUS.BOOKED && obj?.quantity === undefined ? null : obj?.user?.id,
					date:
						obj?.status === STATUS.BOOKED && obj?.quantity !== undefined
							? new Date().toISOString().slice(0, 10)
							: obj?.date,
					quantity: obj?.quantity,
					bookedQuantity: obj?.bookedQuantity,
					remarks: obj?.remarks,
					status:
						obj.status === STATUS.BOOKED && obj?.quantity !== undefined
							? STATUS.APPROVED
							: obj.status
				};
			});
			obj = {
				materialId: materialData?.id,
				userId: selectedUser?.id,
				date: new Date().toISOString().slice(0, 10),
				quantity: item?.issueQuantity,
				remarks: item?.issueRemarks
			};
		}

		if (transactionType.value === TRANSACTION_TYPE.RECEIVE.value && isDataExist()) {
			list.push(obj);
		} else if (transactionType.value === TRANSACTION_TYPE.ISSUE.value && isValitation !== null) {
			list.push(obj);
		}
		await addUpdatedInventory(list, setIsLoading);
	};

	const addUpdatedInventory = async (requestList, setIsLoading) => {
		setIsLoading(true);
		await ApiClient.POST(
			'addUpdatedInventory',
			{ inventoryRequestList: requestList, countryId: selectedCountry?.id },
			materialData?.id + '/' + transactionType.enum
		)
			.then((response) => {
				if (callBack) {
					callBack();
				}
				toastSuccess(response?.data?.message);
				handleClose(viewType);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				}
			});
	};

	const getAllIssueAndReceivedInventory = async () => {
		setIsLoading(true);
		await ApiClient.GET('getAllReceiveAndIssue', materialData?.id)
			.then((response) => {
				setInventoryResponse(response?.data);
				setReceiveInventoryResponseList(response?.data?.receiveInventory);
				setWastageInventoryResponseList(response?.data?.wastageInventory);
				const updatedList = response?.data?.issueInventory.map((obj) => {
					if (!obj.user && obj.bookedUser) {
						return {
							...obj,
							user: {
								id: obj.bookedUser.id,
								name: obj.bookedUser.nickName || obj.bookedUser.name
							}
						};
					}
					return obj;
				});
				setIssueInventoryResponseList(updatedList);
				setUpdateDetails(response?.data?.updateDetailsResponse);
				if (response?.data?.updateDetailsResponse?.countryResponse) {
					let countryRes = response?.data?.updateDetailsResponse?.countryResponse;
					setSelectedCountry({ id: countryRes.id, value: countryRes.name });
				}
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
			});
	};

	const issueStatusUpdated = (item, status) => {
		statusUpdated('inventoryIssueLogStatusUpdated', item?.id, status);
	};

	const receivedStatusUpdated = (item, status) => {
		statusUpdated('inventoryReceivedLogStatusUpdated', item?.id, status);
	};

	const statusUpdated = async (url, id, status) => {
		setIsLoading(true);
		await ApiClient.PUT(url, '', id + '/' + status)
			.then((response) => {
				toastSuccess(response?.data?.message);
				setItem(null);
				getAllIssueAndReceivedInventory()
					.then()
					.finally(() => {
						setIsLoading(false);
					});
				// handleClose(viewType);
			})
			.catch(() => {
				setIsLoading(false);
			});
	};
	const accessCheckApiCall = async (e, productId) => {
		e.stopPropagation();
		setIsLoading(true);
		await ApiClient.GET('productAccessCheck', productId)
			.then(({ data }) => {
				setIsLoading(false);
				if (data)
					window.open(
						`${BASE_FRONT_END_URL}/collections/list?openDesign=true&productId=${productId}`,
						'_blank'
					); // '_blank' opens the URL in a new tab
			})
			.catch((error) => {
				let response = error.response;
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const handleRestrictBookingMaterial = async (logId, isReserved) => {
		try {
			dispatch(openLoader());
			const response = await restrictMaterialBooking(logId, isReserved);
			if (response?.data?.success) {
				getAllIssueAndReceivedInventory();
			}
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const issueAndReceivedInputRender = () => {
		if (requisitionId) {
			return (
				<tr>
					{TRANSACTION_TYPE.ISSUE.value === transactionType.value && <td></td>}

					{/*{TRANSACTION_TYPE.RECEIVE.value ===*/}
					{/*	transactionType.value && (*/}
					{/*	<td className={errorObj?.supplier}>*/}
					{/*		<CustomDropdown*/}
					{/*			type="Supplier"*/}
					{/*			title={'Supplier'}*/}
					{/*			isAddNew={true}*/}
					{/*			onItemClick={onItemClick}*/}
					{/*			items={suppliers}*/}
					{/*			toolTipLength={18}*/}
					{/*			onItemSearch={searchSupplierList}*/}
					{/*			selectedItem={selectedSupplier?.value}*/}
					{/*			showAddNewButton={true}*/}
					{/*			onAddNewButtonClick={() =>*/}
					{/*				goToSupplierNewTab('/suppliers/add')*/}
					{/*			}*/}
					{/*		/>*/}
					{/*	</td>*/}
					{/*)}*/}
					<td className={receiveInventoryErrorObj?.user}>
						<CustomDropdown
							type="User"
							title={'User'}
							onItemClick={onItemClick}
							items={userList}
							selectedItem={selectedUser?.value}
						/>
					</td>
					{TRANSACTION_TYPE.RECEIVE.value === transactionType.value && (
						<td className={receiveInventoryErrorObj?.requestedUser}>
							<CustomDropdown
								type="RequestedUser"
								title={'Requested by'}
								onItemClick={onItemClick}
								items={fixedUserList}
								selectedItem={selectedRequestedUser?.value}
							/>
						</td>
					)}
					<td>
						<p className="text-nowrap">{changeDateFormat(new Date(), '', 'DD MMM, YY')}</p>
					</td>
					{TRANSACTION_TYPE.RECEIVE.value === transactionType.value && (
						<td className={receiveInventoryErrorObj?.location}>
							<CustomDropdown
								type="Location"
								title={'Location'}
								onItemClick={onItemClick}
								items={fixedRACLocationList}
								// onItemSearch={searchRACLocationList}
								selectedItem={selectedRACLocation?.value}
							/>
						</td>
					)}
					{TRANSACTION_TYPE.ISSUE.value === transactionType.value && (
						<td>
							<input
								type="number"
								name="quantity"
								id="quantity"
								placeholder="00"
								min={0}
								onKeyDown={validateFloatNumber}
								value={item?.issueQuantity}
								onChange={(e) => {
									e.preventDefault();
									totalQtySet(e.target.value, 'issueQuantity');
								}}
							/>
						</td>
					)}
					{TRANSACTION_TYPE.RECEIVE.value === transactionType.value && (
						<td>
							<input
								className={receiveInventoryErrorObj?.receiveQuantity}
								type="number"
								name="quantity1"
								id="quantity1"
								placeholder="00"
								min={0}
								onKeyDown={validateFloatNumber}
								value={item?.receiveQuantity}
								onChange={(e) => {
									e.preventDefault();
									totalQtySet(e.target.value, 'receiveQuantity');
								}}
							/>
						</td>
					)}
					{TRANSACTION_TYPE.RECEIVE.value === transactionType.value && (
						<td>
							<div className="form-group purchase-price-column position-relative mb-0">
								<div className="d-flex">
									<input
										className={receiveInventoryErrorObj?.unitPrice}
										type="number"
										name="unitPrice"
										id="unitPrice"
										placeholder="$00.00"
										min={0}
										disabled={unitPriceCurrencyType?.value === 'FOC'}
										onKeyDown={validateFloatNumber}
										value={item?.unitPrice || ''}
										onChange={(e) => totalPriceSet(e)}
									/>

									<div className="purchase-price-dropdown">
										<div
											className={`form-group size36 mb-0 ${receiveInventoryErrorObj?.unitPriceCurrencyType}`}
										>
											<CustomDropdown
												type="fabricName"
												title={'Select'}
												items={PURCHASE_PRICE_TYPES}
												toolTipLength={13}
												isShowSearch={false}
												onItemClick={(obj) => {
													setUnitPriceCurrencyType(obj);
													if (obj.value === 'FOC') {
														setItem({
															...item,
															unitPrice: undefined
														});
													}
												}}
												selectedItem={unitPriceCurrencyType?.value}
											/>
										</div>
									</div>
								</div>

								{/* {errors2.gsmError && (
                              <p className="error">{errors2.gsmError}</p>
                            )} */}
							</div>
						</td>
					)}
					{TRANSACTION_TYPE.ISSUE.value === transactionType.value && (
						<td>
							<textarea
								className="table-column-textarea"
								name="remarks"
								id="remarks"
								//placeholder="Remarks will go here"
								defaultValue={''}
								value={item?.issueRemarks}
								onChange={(e) =>
									setItem({
										...item,
										['issueRemarks']: e.target.value
									})
								}
							/>
						</td>
					)}
					{TRANSACTION_TYPE.RECEIVE.value === transactionType.value && (
						<>
							<td>
								<input
									className={receiveInventoryErrorObj?.chalanNo}
									type="text"
									name="chalanNo"
									id="chalanNo"
									value={item?.chalanNo || ''}
									onChange={(e) =>
										setItem({
											...item,
											['chalanNo']: e.target.value
										})
									}
								/>
							</td>
							<td>
								<input
									className={receiveInventoryErrorObj?.invoiceNo}
									type="text"
									name="invoiceNo"
									id="invoiceNo"
									value={item?.invoiceNo || ''}
									onChange={(e) =>
										setItem({
											...item,
											['invoiceNo']: e.target.value
										})
									}
								/>
							</td>
						</>
					)}
					{TRANSACTION_TYPE.RECEIVE.value === transactionType.value && (
						<td>
							<textarea
								className="table-column-textarea"
								name="remarks1"
								id="remarks1"
								//placeholder="Remarks will go here"
								defaultValue={''}
								value={item?.receiveRemarks}
								onChange={(e) =>
									setItem({
										...item,
										['receiveRemarks']: e.target.value
									})
								}
							/>
						</td>
					)}
					<td></td>
				</tr>
			);
		}
	};

	const isDataExist = () => {
		return (
			selectedUser?.value ||
			selectedRequestedUser?.value ||
			selectedRACLocation?.value ||
			unitPriceCurrencyType?.value ||
			(item !== null && Object.keys(item).length > 0)
		);
	};

	const isInvalidReceivedTableValidation = () => {
		let errorObj = {};
		if (!selectedCountry?.id) {
			errorObj['inventoryCountry'] = 'common-border-error';
		}
		receiveInventoryResponseList.forEach((item) => {
			if (inventoryEditPermission(materialData) && item.status !== 'DISABLED') {
				if (!item.chalanNo) {
					errorObj[`receiveChallan_${item.id}`] = 'common-border-error';
				}
				if (!item.invoiceNo) {
					errorObj[`receiveInvoice_${item.id}`] = 'common-border-error';
				}
			}
		});
		if (isDataExist()) {
			if (!selectedUser?.value) {
				errorObj['user'] = 'common-border-error';
			}
			if (!item?.receiveQuantity) {
				errorObj['receiveQuantity'] = 'common-border-error';
			}
			if (!selectedRequestedUser?.value) {
				errorObj['requestedUser'] = 'common-border-error';
			}
			if (!selectedRACLocation?.value) {
				errorObj['location'] = 'common-border-error';
			}
			if (!unitPriceCurrencyType?.value) {
				errorObj['unitPriceCurrencyType'] = 'common-border-error';
			}
			if (unitPriceCurrencyType?.value !== 'FOC' && !item?.unitPrice) {
				errorObj['unitPrice'] = 'common-border-error';
			}
			if (!item?.chalanNo) {
				errorObj['chalanNo'] = 'common-border-error';
			}
			if (!item?.invoiceNo) {
				errorObj['invoiceNo'] = 'common-border-error';
			}
		}
		setReceiveInventoryErrorObj(errorObj);
		return Object.keys(errorObj).length > 0;
	};

	return (
		<>
			<Modal
				show={show}
				onHide={handleClose}
				backdrop="static"
				centered
				className="inventory-update-modal"
			>
				<LoaderComponent loading={isLoading}>
					<div className="common-popup inventory-update-modal">
						<Modal.Header closeButton className="no-border">
							<Modal.Title className="semibold-16 mb-0">
								{' '}
								<span>
									Update inventory :{' '}
									{inventoryResponse?.fabricReferenceNumber
										? ' ' + inventoryResponse?.fabricReferenceNumber
										: ' '}
									,
								</span>
								<span className="gray_dark_02 ml-1">
									Store Qty:{' '}
									{inventoryResponse?.stockQuantity
										? parseFloat(inventoryResponse?.stockQuantity)
												.toFixed(2)
												.replace('.00', '')
										: '0'}
									{consumptionUnit}, Booked:{' '}
									{parseFloat(inventoryResponse?.bookedQuantity)
										.toFixed(2)
										.replace('.00', '') +
										' ' +
										consumptionUnit}
									, Inventory location:{' '}
									{inventoryResponse?.updateDetailsResponse?.countryResponse?.name}
								</span>
								{materialData?.isReserved &&
									userInfo?.nickName !== materialData?.reservedFor && (
										<RestrictedInfo item={materialData} viewType="inline-view" />
									)}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="common-popup-body scroll-y-label scroll-x-label">
								<div className="inner-tabs mb-3">
									<ul>
										<li
											onClick={() => setTransactionType(TRANSACTION_TYPE.ISSUE)}
											className={`${isReceiveTabSelected ? 'cursor-none' : ''} ${
												TRANSACTION_TYPE.ISSUE.value === transactionType.value
													? 'active'
													: ''
											}`}
										>
											Issue
										</li>
										<li
											onClick={() => setTransactionType(TRANSACTION_TYPE.RECEIVE)}
											className={
												TRANSACTION_TYPE.RECEIVE.value === transactionType.value
													? 'active'
													: ''
											}
										>
											Receive
										</li>
										<li
											onClick={() => setTransactionType(TRANSACTION_TYPE.WASTAGE)}
											className={`${isReceiveTabSelected ? 'cursor-none' : ''} ${
												TRANSACTION_TYPE.WASTAGE.value === transactionType.value
													? 'active'
													: ''
											}`}
										>
											Wastage
										</li>
									</ul>
								</div>

								{transactionType.value === 'Receive' && (
									<div className="inventory-update-details mb-3">
										<div className="d-flex align-items-center justify-content-between mb-2">
											<p className="semibold-14">Update Details</p>
											<p className="regular-14 gray_dark_02">
												Last update:{' '}
												<span className="gray_dark_01">
													{changeDateFormat(
														updateDetails.lastUpdatedAt,
														'YYYY-MM-DD',
														'DD MMM, YYYY'
													)}
													, {updateDetails?.updatedBy}
												</span>
											</p>
										</div>
										<div className="d-flex">
											<div className="one-third">
												<label>Country *</label>
												<div className="transparent-select">
													<div className="select-component">
														<div
															className={`click-box click mb-1 ${receiveInventoryErrorObj?.inventoryCountry}`}
														>
															<CustomDropdown
																title={'Select'}
																onItemClick={(selected) => {
																	setSelectedCountry(selected);
																}}
																items={getCountryList?.map((item) => ({
																	id: item.id,
																	value: item.name
																}))}
																selectedItem={selectedCountry?.value || ''}
															/>
														</div>
													</div>
												</div>
											</div>
											<div className="one-third">
												<p className="regular-14 gray_dark_02 mb-2">
													Challan No:
													<span className="gray_dark_01 ml-1">
														{updateDetails?.chalanNo}
													</span>
												</p>
												<p className="regular-14 gray_dark_02">
													Invoice No:
													<span className="gray_dark_01 ml-1">
														{updateDetails?.invoiceNo}
													</span>
												</p>
											</div>
											<div className="one-third">
												<p className="regular-14 gray_dark_02 mb-2">
													Purchase Price:
													<span className="gray_dark_01">
														{updateDetails?.purchasePrice
															? `$${updateDetails?.purchasePrice}`
															: ''}
													</span>
												</p>
												<p className="regular-14 gray_dark_02">
													Fabric Qty:
													<span className="gray_dark_01">
														{updateDetails?.quantity}{' '}
														{updateDetails?.quantityType}
													</span>
												</p>
											</div>
										</div>
									</div>
								)}
								{[TRANSACTION_TYPE.RECEIVE.value, TRANSACTION_TYPE.ISSUE.value].includes(
									transactionType.value
								) ? (
									<div className="w-100 scroll-x-label inventory-table-wrapper">
										<table
											className={`table with-border no-hover height-sm inventory-update-table ${transactionType.value}`}
										>
											<thead>
												<tr>
													{TRANSACTION_TYPE.ISSUE.value ===
														transactionType.value && (
														<th className="booked">Booked by</th>
													)}
													{TRANSACTION_TYPE.ISSUE.value ===
														transactionType.value && (
														<th className="booked">Booking details</th>
													)}
													{TRANSACTION_TYPE.ISSUE.value ===
														transactionType.value && (
														<th className="booked">
															Booked Qty (
															{updateDetails?.quantityType
																? updateDetails.quantityType
																: consumptionUnit}
															)
														</th>
													)}
													{TRANSACTION_TYPE.ISSUE.value ===
														transactionType.value && (
														<th className="booked">
															Issue Qty (
															{updateDetails?.quantityType
																? updateDetails.quantityType
																: consumptionUnit}
															)
														</th>
													)}
													<th>
														{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value
															? 'Sourced by'
															: 'Issued to'}
													</th>
													{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value && <th>Requested by</th>}
													<th>
														{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value
															? 'Date'
															: 'Issue Date'}
													</th>
													{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value && <th>Rack NO</th>}
													{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value && (
														<th>
															Qty (
															{updateDetails?.quantityType
																? updateDetails.quantityType
																: consumptionUnit}
															)
														</th>
													)}
													{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value && (
														<th>
															Unit price/(
															{updateDetails?.quantityType
																? updateDetails.quantityType
																: consumptionUnit}
															)
														</th>
													)}
													{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value && (
														<th className="text-nowrap">Challan No.*</th>
													)}
													{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value && (
														<th className="text-nowrap">Invoice No.</th>
													)}
													<th className="remarks">Remarks</th>
													{TRANSACTION_TYPE.ISSUE.value ===
														transactionType.value && (
														<th className="booked">Total calculation</th>
													)}
													<th>Action</th>
												</tr>
											</thead>
											<tbody>
												{TRANSACTION_TYPE.ISSUE.value === transactionType.value &&
													issueInventoryResponseList?.map((item, index) => {
														return (
															<tr
																key={'issue_' + index}
																className={
																	[
																		STATUS.REJECTED,
																		STATUS.RETURNED,
																		STATUS.CANCELLED
																	].includes(item?.status)
																		? 'disabled'
																		: ''
																}
															>
																<td>
																	{item?.bookedQuantity && (
																		<>
																			<p>
																				{userNameSet(
																					item?.bookedUser
																				)}
																			</p>
																			<p>
																				<span>
																					{changeDateFormat(
																						item?.bookedDate,
																						'YYYY-MM-DD',
																						'DD MMM, YYYY'
																					)}
																				</span>
																			</p>
																		</>
																	)}
																</td>
																<td>
																	<span className="regular-14 gray_dark_01">
																		<p>
																			<span
																				onClick={(e) =>
																					accessCheckApiCall(
																						e,
																						item?.productId
																					)
																				}
																				className="f-title hover-underline cursor-pointer"
																			>
																				{item?.productRefNumber}
																			</span>
																		</p>

																		<p className="regular-12 gray_dark_02 mt-1">
																			{item?.productName}
																		</p>
																	</span>
																</td>
																<td>
																	<span>
																		{[
																			STATUS.CANCELLED,
																			STATUS.EXPIRED
																		].includes(item?.status) && (
																			<del>{item?.bookedQuantity}</del>
																		)}
																		{![
																			STATUS.CANCELLED,
																			STATUS.EXPIRED
																		].includes(item?.status) && (
																			<>{item?.bookedQuantity}</>
																		)}
																	</span>
																	{item?.status === STATUS.CANCELLED && (
																		<span className="red">
																			{' '}
																			(Canceled)
																		</span>
																	)}
																	{item?.status === STATUS.EXPIRED && (
																		<span className="red">
																			{' '}
																			(Expired)
																		</span>
																	)}
																	{!item?.quantity &&
																		item?.status === STATUS.REJECTED && (
																			<span className="red">
																				{' '}
																				(Deleted)
																			</span>
																		)}
																</td>
																<td>
																	{item?.status === STATUS.BOOKED ? (
																		inventoryEditPermission(
																			materialData
																		) && (
																			<input
																				type="number"
																				name={
																					'quantity_issue' +
																					item?.id
																				}
																				id={
																					'quantity_issue' +
																					item?.id
																				}
																				placeholder="00"
																				min={0}
																				onKeyDown={
																					validateFloatNumber
																				}
																				value={
																					item?.id ===
																					issueQuantity?.id
																						? issueQuantity?.quantity
																						: undefined
																				}
																				onChange={(e) =>
																					setIssueQuantity({
																						id: item?.id,
																						quantity:
																							e.target.value
																					})
																				}
																			/>
																		)
																	) : (
																		<>
																			{item?.quantity}
																			{item?.status ===
																				STATUS.RETURNED && (
																				<span className="red">
																					{' '}
																					(Returned)
																				</span>
																			)}
																			{item?.quantity &&
																				item?.status ===
																					STATUS.REJECTED && (
																					<span className="red">
																						{' '}
																						(Deleted)
																					</span>
																				)}
																		</>
																	)}
																</td>
																<td className={errorObj?.['user' + index]}>
																	{item?.status === STATUS.BOOKED
																		? inventoryEditPermission(
																				materialData
																			) && (
																				<CustomDropdown
																					type="User"
																					title={'User'}
																					onItemClick={(
																						userItem
																					) => {
																						setIssueByUser({
																							...userItem,
																							itemId: item?.id
																						});
																					}}
																					items={fixedUserList}
																					selectedItem={
																						item?.user?.name
																					}
																				/>
																			)
																		: userNameSet(item?.user)}
																</td>
																<td>
																	{changeDateFormat(
																		item?.status == STATUS.BOOKED
																			? new Date()
																			: item?.date,
																		'YYYY-MM-DD',
																		'DD MMM, YY'
																	)}
																</td>
																<td className="remarks-column">
																	{inventoryEditPermission(
																		materialData
																	) && (
																		<textarea
																			className="table-column-textarea"
																			name={'remarks_issue' + item?.id}
																			id={'remarks_issue' + item?.id}
																			//placeholder="Remarks will go here"
																			defaultValue={item?.remarks}
																			value={
																				item?.id === itemRemarks?.id
																					? itemRemarks?.remarks
																					: item?.remarks
																			}
																			onChange={(e) =>
																				setItemRemarks({
																					id: item?.id,
																					remarks: e.target.value
																				})
																			}
																		/>
																	)}
																	{!inventoryEditPermission(materialData) &&
																		item?.remarks}
																</td>
																{index === 0 && (
																	<td
																		rowSpan={
																			issueInventoryResponseList.length
																		}
																		className="calculation-column"
																	>
																		<p className="regular-14 gray_dark_02">
																			Fabric Owner:{' '}
																			<span className="semibold-14 gray_dark_02">
																				{
																					inventoryResponse?.fabricOwner
																				}
																			</span>
																		</p>
																		<p className="calculation-item">
																			<span className="regular-12">
																				Received:{' '}
																			</span>
																			<span className="inventory-value booked">
																				{
																					inventoryResponse?.receivedQuantity
																				}
																				{` ${consumptionUnit}`}
																			</span>
																		</p>
																		<p className="calculation-item">
																			<span className="regular-12">
																				Issue:{' '}
																			</span>
																			<span className="inventory-value booked">
																				{
																					inventoryResponse?.issuedQuantity
																				}
																				{` ${consumptionUnit}`}
																			</span>
																		</p>

																		<p className="calculation-item">
																			<span className="regular-12">
																				Wastage:{' '}
																			</span>
																			<span className="inventory-value">
																				{
																					inventoryResponse?.wastageQuantity
																				}
																				{` ${consumptionUnit}`}
																			</span>
																		</p>
																		<p className="calculation-item">
																			<span className="regular-12">
																				Store Qty:{' '}
																			</span>
																			<span className="inventory-value">
																				{
																					inventoryResponse?.stockQuantity
																				}
																				{` ${consumptionUnit}`}
																			</span>
																		</p>
																		<p className="calculation-item">
																			<span className="regular-12">
																				Booked:{' '}
																			</span>
																			<span className="inventory-value booked">
																				{
																					inventoryResponse?.bookedQuantity
																				}
																				{` ${consumptionUnit}`}
																			</span>
																		</p>
																		<p className="calculation-item">
																			<span className="regular-12">
																				Balance:{' '}
																			</span>
																			<span className="inventory-value">
																				{
																					inventoryResponse?.balanceQuantity
																				}
																				{` ${consumptionUnit}`}
																			</span>
																		</p>
																		<div className="mt-2">
																			<Tooltip
																				title={
																					<ul className="common-list-component explanation">
																						<li>
																							Store Qty= (Total
																							received - Total
																							issued) Currently
																							physically
																							available in the
																							store.
																						</li>
																						<li>
																							Booked: Quantity
																							currently booked,
																							not yet issued by
																							the store manager.
																						</li>
																						<li>
																							Balance=(Received
																							- Issue + Book){' '}
																							<br />
																							It’s a useable
																							balance
																						</li>
																					</ul>
																				}
																				placement="top"
																				arrow
																			>
																				<p className="d-flex align-items-center cursor-pointer">
																					<img
																						src={`${process.env.PUBLIC_URL}/icons/info.svg`}
																						alt="info"
																					/>
																					<span className="regular-12 gray_dark_02 ml-1">
																						Explanation
																					</span>
																				</p>
																			</Tooltip>
																		</div>
																	</td>
																)}
																<td>
																	{![
																		STATUS.REJECTED,
																		STATUS.RETURNED,
																		STATUS.CANCELLED
																	].includes(item?.status) &&
																		inventoryEditPermission(
																			materialData
																		) && (
																			<div className="d-flex align-items-center">
																				<div className="option">
																					<div className="dropdown">
																						<button
																							className="btn btn-default dropdown-toggle"
																							type="button"
																							id="menu1"
																							data-toggle="dropdown"
																							aria-expanded="false"
																						>
																							<MoreIcon />
																						</button>
																						<ul
																							className="dropdown-menu dropdown-menu-right shadow-lg"
																							role="menu"
																							aria-labelledby="menu1"
																						>
																							{(item?.status ===
																								STATUS.APPROVED ||
																								item?.status ===
																									STATUS.ACTIVE) && (
																								<>
																									<li>
																										<span
																											className="text-nowrap pr-5"
																											onClick={() =>
																												issueStatusUpdated(
																													item,
																													STATUS.RETURNED
																												)
																											}
																										>
																											Return
																											to
																											inventory
																										</span>
																									</li>
																									<li>
																										<span
																											className="text-nowrap pr-5"
																											onClick={() =>
																												setSelectedAdditionalFabric(
																													item
																												)
																											}
																										>
																											Issue
																											additional
																											fabric
																										</span>
																									</li>
																								</>
																							)}
																							{item?.status ===
																								STATUS.BOOKED && (
																								<li>
																									<span
																										className="text-nowrap pr-5"
																										onClick={() =>
																											issueStatusUpdated(
																												item,
																												STATUS.CANCELLED
																											)
																										}
																									>
																										Cancel
																										book
																									</span>
																								</li>
																							)}
																						</ul>
																					</div>
																				</div>
																			</div>
																		)}
																</td>
															</tr>
														);
													})}
												{TRANSACTION_TYPE.RECEIVE.value === transactionType.value &&
													receiveInventoryResponseList?.map((item, index) => {
														return (
															<tr
																key={'receive_' + index}
																className={
																	item.status === STATUS.DISABLED
																		? 'disabled'
																		: ''
																}
															>
																{/*<td>*/}
																{/*	<span>*/}
																{/*		{item?.materialType ===*/}
																{/*		MATERIALS_TYPE.DESIGN_FABRIC*/}
																{/*			? 'Design fabric'*/}
																{/*			: item?.supplier?.name}*/}
																{/*	</span>*/}
																{/*</td>*/}
																<td>
																	<span>{userNameSet(item?.user)}</span>
																</td>
																<td>
																	<span>
																		{userNameSet(item?.requestedUser)}
																	</span>
																</td>
																<td>
																	<p className="text-nowrap">
																		{changeDateFormat(
																			item?.date,
																			'YYYY-MM-DD',
																			'DD MMM, YY'
																		)}
																	</p>
																</td>
																<td>
																	{/*<span>{item?.location?.name}</span>*/}
																	<CustomDropdown
																		type="Location"
																		title={'Location'}
																		onItemClick={(item) => {
																			let tmpRes = [
																				...receiveInventoryResponseList
																			];
																			tmpRes[index].location = {
																				id: item.id,
																				name: item.value
																			};
																			setReceiveInventoryResponseList(
																				tmpRes
																			);
																		}}
																		items={fixedRACLocationList}
																		selectedItem={item?.location?.name}
																	/>
																</td>
																<td className="text-nowrap">
																	{item.status === 'DISABLED' && (
																		<del>{item?.quantity}</del>
																	)}
																	{item.status !== 'DISABLED' && (
																		<span>{item?.quantity}</span>
																	)}
																	{item.status === 'DISABLED' && (
																		<span className="red ml-2">
																			(Wrong Entry)
																		</span>
																	)}
																</td>
																<td>
																	<span>
																		{item.unitPrice
																			? item.unitPrice
																			: 'FOC'}
																	</span>
																</td>
																<td>
																	{!item.chalanNo &&
																		inventoryEditPermission(
																			materialData
																		) && (
																			<input
																				type="text"
																				name={
																					'chalanNo_receive' +
																					item?.id
																				}
																				id={
																					'chalanNo_receive' +
																					item?.id
																				}
																				className={
																					receiveInventoryErrorObj[
																						`receiveChallan_${item.id}`
																					]
																				}
																				value={
																					item?.id ===
																					itemChallan?.id
																						? itemChallan?.chalanNo ||
																							''
																						: item?.chalanNo || ''
																				}
																				onChange={(e) =>
																					setItemChallan({
																						id: item?.id,
																						chalanNo:
																							e.target.value
																					})
																				}
																				readOnly={
																					item.status === 'DISABLED'
																				}
																			/>
																		)}
																	{item.chalanNo && item.chalanNo}
																</td>
																<td>
																	{!item?.invoiceNo &&
																		inventoryEditPermission(
																			materialData
																		) && (
																			<input
																				type="text"
																				name={
																					'invoiceNo_receive' +
																					item?.id
																				}
																				id={
																					'invoiceNo_receive' +
																					item?.id
																				}
																				className={
																					receiveInventoryErrorObj[
																						`receiveInvoice_${item.id}`
																					]
																				}
																				value={
																					item?.id ===
																					itemInvoice?.id
																						? itemInvoice?.invoiceNo ||
																							''
																						: item?.invoiceNo ||
																							''
																				}
																				onChange={(e) =>
																					setItemInvoice({
																						id: item?.id,
																						invoiceNo:
																							e.target.value
																					})
																				}
																				readOnly={
																					item.status === 'DISABLED'
																				}
																			/>
																		)}
																	{item.invoiceNo && item.invoiceNo}
																</td>
																<td>
																	{inventoryEditPermission(
																		materialData
																	) && (
																		<span>
																			<textarea
																				className="table-column-textarea"
																				name={
																					'remarks_receive' +
																					item?.id
																				}
																				id={
																					'remarks_receive' +
																					item?.id
																				}
																				//placeholder="Remarks will go here"
																				defaultValue={item?.remarks}
																				value={
																					item?.id ===
																					itemRemarks?.id
																						? itemRemarks?.remarks
																						: item?.remarks
																				}
																				onChange={(e) =>
																					setItemRemarks({
																						id: item?.id,
																						remarks:
																							e.target.value
																					})
																				}
																			/>
																		</span>
																	)}
																	{!inventoryEditPermission(materialData) &&
																		item.remarks}
																</td>
																<td>
																	{inventoryEditPermission(
																		materialData
																	) && (
																		<div className="d-flex align-items-center">
																			<div className="option">
																				<div className="dropdown">
																					<button
																						className="btn btn-default dropdown-toggle"
																						type="button"
																						id="menu1"
																						data-toggle="dropdown"
																						aria-expanded="false"
																					>
																						<MoreIcon />
																					</button>
																					<ul
																						className="dropdown-menu dropdown-menu-right shadow-lg"
																						role="menu"
																						aria-labelledby="menu1"
																					>
																						{item.status ===
																							STATUS.DISABLED && (
																							<li>
																								<span
																									className="text-nowrap pr-5"
																									onClick={() =>
																										receivedStatusUpdated(
																											item,
																											STATUS.ACTIVE
																										)
																									}
																								>
																									Make it
																									right
																									entry
																								</span>
																							</li>
																						)}
																						<li>
																							{item.status ===
																								STATUS.ACTIVE && (
																								<>
																									<span
																										className="text-nowrap pr-5"
																										onClick={() =>
																											receivedStatusUpdated(
																												item,
																												STATUS.DISABLED
																											)
																										}
																									>
																										Wrong
																										entry
																									</span>
																								</>
																							)}
																						</li>
																						<li
																							onClick={() =>
																								handleRestrictBookingMaterial(
																									item?.id,
																									!item?.isReserved
																								)
																							}
																						>
																							<span className="text-nowrap pr-5">
																								{item?.isReserved
																									? 'Withdraw Restriction'
																									: 'Restrict booking for 20days'}
																							</span>
																						</li>
																					</ul>
																				</div>
																			</div>
																		</div>
																	)}
																</td>
															</tr>
														);
													})}

												{isFabric(materialData?.materialType?.toUpperCase()) &&
													TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value &&
													inventoryEditPermission(materialData) &&
													issueAndReceivedInputRender()}
												{!isFabric(materialData?.materialType?.toUpperCase()) &&
													inventoryEditPermission(materialData) &&
													issueAndReceivedInputRender()}
												<tr>
													<td>
														<span className="semibold-14">Total</span>
													</td>
													<td />
													<td>
														{TRANSACTION_TYPE.ISSUE.value ===
															transactionType.value && (
															<span className="semibold-14">
																{parseFloat(inventoryResponse?.bookedQuantity)
																	.toFixed(2)
																	.replace('.00', '') + ' '}{' '}
																{updateDetails?.quantityType
																	? updateDetails.quantityType
																	: consumptionUnit}
															</span>
														)}
													</td>
													{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value && <td />}
													<td>
														<span className="semibold-14">
															{totalQuantity}{' '}
															{updateDetails?.quantityType
																? updateDetails.quantityType
																: consumptionUnit}
														</span>
													</td>
													{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value && (
														<td>
															<span className="semibold-14">
																${totalUnitPrice.toFixed(2)}
															</span>
														</td>
													)}
													{TRANSACTION_TYPE.RECEIVE.value ===
														transactionType.value && <td />}
													<td />
													<td />
													<td />
												</tr>
											</tbody>
										</table>
									</div>
								) : (
									<WastageTab
										wastageList={wastageInventoryResponseList}
										consumptionUnit={consumptionUnit}
										getAllIssueAndReceivedInventory={getAllIssueAndReceivedInventory}
									/>
								)}
							</div>
						</Modal.Body>
						<Modal.Footer>
							{inventoryEditPermission(materialData) &&
								TRANSACTION_TYPE.WASTAGE.value !== transactionType.value && (
									<div className="footer-buttons text-right">
										<button
											className="button outline size32"
											onClick={() => handleClose('Cancel')}
										>
											Cancel
										</button>
										<button
											disabled={isLoading}
											className="button size32 ml-2"
											onClick={() => onSubmit()}
										>
											Submit
										</button>
									</div>
								)}
						</Modal.Footer>
					</div>
				</LoaderComponent>
			</Modal>
			{selectedAdditionalFabric && (
				<AdditionalFabricModal
					onClose={() => setSelectedAdditionalFabric(null)}
					productId={selectedAdditionalFabric?.productId}
					issueLogId={selectedAdditionalFabric?.id}
					materialType={materialData?.materialType?.toUpperCase().replace(' ', '_')}
					onSuccess={() => {
						setSelectedAdditionalFabric(null);
						getAllIssueAndReceivedInventory();
					}}
				/>
			)}
		</>
	);
};

export default MaterialInventory;
